import { Component } from "react";
import { connect } from "react-redux";
import { CalculatePriceWorker } from "../../../helper/worker/CalculatePriceWorker";
import { DetectOndemandOrReserve } from "../../../helper/worker/DetectOndemandOrReserve";
import { CalculatePrice_Delivery_Worker } from "../../../helper/worker/CalculatePrice_Delivery_Worker";
import { CanOrderCalculateTravelCost } from "../../../helper/worker/CanOrderCalculateTravelCost";
import momentJalaali from "moment-jalaali";
import { EdittPriceNewOrderChanged, EdittPriceNewOrder_manualy, SetPriceNewOrder } from "../../../Redux/actions/actionNames";

class App extends Component {
  componentDidMount() {
    CalculatePrice_Delivery_Worker(
      {
        // customerType:this.props.person ,
        customerId : this.props.customerId,
        serviceactiveVehicleType: this.props.serviceactiveVehicleType,
        serviceoptions: this.props.serviceoptions,
        auto: this.props.auto,
        driveroptions: this.props.driveroptions,
        auto_activeVehicleType: this.props.auto_activeVehicleType,
        manual_activeVehicleType:
          this.props.manual_activeVehicleType,
        dropOff: {
          address: this.props.dropOff.address,
          scheduleDateAfter: (this.props.dropOff.scheduleDateAfter && momentJalaali(
            this.props.dropOff.scheduleDateAfter
          ).isValid())
            ? momentJalaali(
                Number(this.props.dropOff.scheduleDateAfter + "000")
              ).unix()
            : 0,
          scheduleDateBefore: (this.props.dropOff.scheduleDateBefore && momentJalaali(
            this.props.dropOff.scheduleDateBefore
          ).isValid())
            ? momentJalaali(
                Number(this.props.dropOff.scheduleDateBefore + "000")
              ).unix()
            : 0,
          // senderFullName: this.props.pickup.senderFullName,
          // senderPhoneNumber: this.props.pickup.senderPhoneNumber,
          // unit: this.props.pickup.unit,
        },
        dropOffadresss_loc: this.props.dropOffadresss_loc,
        isScheduled:DetectIsSchedule(this.props.dropOff)

      },
      this.props.dispatch
    );
  }

  componentWillReceiveProps(nextProps) {
    
    CanOrderCalculateTravelCost(
      {
        customerId : this.props.customer?.id ,

         firstDropOffRequiredCheck:this.firstDropOffRequiredCheck(this.props) , 
         // customerType:this.props.person ,
        calculatedPrice: (this.props.Pricechanged == false && (nextProps.Pricechanged !== this.props.Pricechanged)) ? true : false,

        serviceactiveVehicleType: this.props.serviceactiveVehicleType,
        serviceoptions: this.props.serviceoptions,
        driveroptions: this.props.driveroptions,
        auto_activeVehicleType: this.props.auto_activeVehicleType,
        manual_activeVehicleType: this.props.manual_activeVehicleType,
          dropOffadresss_loc: this.props.dropOffadresss_loc,
      },
      {
         customerId : nextProps.customer?.id ,

         firstDropOffRequiredCheck:this.firstDropOffRequiredCheck(nextProps) , 
         // customerType:nextProps.person ,
        calculatedPrice: (nextProps.Pricechanged == true && (nextProps.Pricechanged !== this.props.Pricechanged)) ? false : false,

        serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
        serviceoptions: nextProps.serviceoptions,
        driveroptions: nextProps.driveroptions,
        auto_activeVehicleType: nextProps.auto_activeVehicleType,
        manual_activeVehicleType: nextProps.manual_activeVehicleType,
          dropOffadresss_loc: nextProps.dropOffadresss_loc,
      },
      (call) => {
        

        if (call && this.firstDropOffRequiredCheck(nextProps) ) {
          CalculatePrice_Delivery_Worker(
            {
              // customerType:nextProps.person,
              customerId : nextProps.customerId,

              PREV : (nextProps.manually_changed && nextProps.PriceCalculated) ? {
                surcharges: nextProps.PriceCalculated.surcharges.map((surchargesItem)=>{
                  return        {
                    id: surchargesItem.id,
                    surchargeId: surchargesItem.surchargeId,
                    price: surchargesItem.price
                  }
                }) ,
                baseFarePrice: nextProps.PriceCalculated.baseFarePrice,
                tax: nextProps.PriceCalculated.tax,
              } : null,
              
              serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
              serviceoptions: nextProps.serviceoptions,
              auto: nextProps.auto,
              driveroptions: nextProps.driveroptions,
              auto_activeVehicleType: nextProps.auto_activeVehicleType,
              manual_activeVehicleType:
                nextProps.manual_activeVehicleType,
                dropOff: {
                address: nextProps.dropOff.address,
                scheduleDateAfter: (nextProps.dropOff.scheduleDateAfter && momentJalaali(
                  nextProps.dropOff.scheduleDateAfter
                ).isValid())
                  ? momentJalaali(
                      Number(nextProps.dropOff.scheduleDateAfter + "000")
                    ).unix()
                  : 0,
                scheduleDateBefore: (nextProps.dropOff.scheduleDateBefore && momentJalaali(
                  nextProps.dropOff.scheduleDateBefore
                ).isValid())
                  ? momentJalaali(
                      Number(nextProps.dropOff.scheduleDateBefore + "000")
                    ).unix()
                  : 0,
                // senderFullName: nextProps.pickup.senderFullName,
                // senderPhoneNumber: nextProps.pickup.senderPhoneNumber,
                // unit: nextProps.pickup.unit,
              },
              dropOffadresss_loc: nextProps.dropOffadresss_loc,
              isScheduled:DetectIsSchedule(nextProps.dropOff)
            },
            this.props.dispatch
          );

          this.props.dispatch(EdittPriceNewOrderChanged(false))
          if(nextProps.manually_changed){
            this.props.dispatch(EdittPriceNewOrder_manualy(false))
          }
        }else if(!this.firstDropOffRequiredCheck(nextProps)){
                        this.props.dispatch(SetPriceNewOrder({ done: false }, { done: false ,where:"205" }));
                  
                }
      }
    );
  }


  firstDropOffRequiredCheck = (props) => {
    if (props.serviceactiveVehicleType) {
      let name = false, email = false, phone = false;

      if (props.serviceactiveVehicleType.setting.isDropoffAddressNameRequired) {
        if (props.firstDropOff.recieverFullName && String(props.firstDropOff.recieverFullName).trim().length > 0) {
          name = true
        } else {
          name = false
        }
      } else {
        name = true
      }

      if (props.serviceactiveVehicleType.setting.isDropoffAddressPhoneRequired) {
        if (props.firstDropOff.recieverPhoneNumber && String(props.firstDropOff.recieverPhoneNumber).trim().length > 0) {
          phone = true
        } else {
          phone = false
        }
      } else {
        phone = true
      }


      if (props.serviceactiveVehicleType.setting.isDropoffAddressEmailRequired) {
        if (props.firstDropOff.email && String(props.firstDropOff.email).length > 0 && this.emailValidate(String(props.firstDropOff.email))) {
          email = true
        } else {
          email = false
        }
      } else {
        email = true
      }



      return (name && phone && email);

    } else {
      return false
    }

  }



  emailValidate(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }


  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  person: state.NewOrder.newOrder.customer.type || null,
  serviceactiveVehicleType: state.NewOrder.newOrder.service.activeVehicleType,
  serviceoptions: state.NewOrder.newOrder.service.options,
  customerId : state.NewOrder.newOrder.customer.id || null,

  auto: state.NewOrder.newOrder.driver.auto,
  driveroptions: state.NewOrder.newOrder.driver.options,
  auto_activeVehicleType:
    state.NewOrder.newOrder.driver.auto_driver.auto_activeVehicleType,
  manual_activeVehicleType:
    state.NewOrder.newOrder.driver.manual_driver.manual_activeVehicleType,
  dropOff: state.NewOrder.newOrder.dropOffs.firstDropOff,
  dropOffadresss_loc: state.NewOrder.newOrder.dropOffs.firstDropOff.adresss_loc,
  firstDropOff: state.NewOrder.newOrder.dropOffs.firstDropOff,
  firstDropOffadresss_loc:
    state.NewOrder.newOrder.dropOffs.firstDropOff.adresss_loc,
  Pricechanged: state.NewOrder.newOrder.price.changed,
  PriceCalculated: state.NewOrder.newOrder.price.price,
  customer: state.NewOrder.newOrder.customer,
  manually_changed: state.NewOrder.newOrder.price.changed,

});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



function DetectIsSchedule(dropOff) {
  if ( (Number(dropOff.scheduleDateBefore) > 0 ||  dropOff.scheduleDateBefore != null ) || ( Number(dropOff.scheduleDateAfter || dropOff.scheduleDateAfter != null )) > 0) {
    return true
  } else {
    return false

  }

}
